import { MetaObjectField } from '../types';

export const PREVENTION_QUERY = `
  query Prevention($typename: String!) {
    metaobjects(type: $typename, first: 10, sortKey: "updated_at", reverse:true) {
      nodes {
        fields {
          key,
          value,
          type
        }
        updatedAt
      }
    }
  }
`;

export type PreventionQueryVariants = {
  typename: string;
};

export type PreventionQueryResponse = {
  metaobjects: {
    nodes: PreventionMetaObjectNode[];
  };
};

export type PreventionMetaObjectNode = {
  fields: MetaObjectField[];
  updatedAt: string;
};
